import { render, staticRenderFns } from "./ProposalsEdit.vue?vue&type=template&id=3567047e&scoped=true&"
import script from "./ProposalsEdit.vue?vue&type=script&lang=js&"
export * from "./ProposalsEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProposalsEdit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProposalsEdit.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ProposalsEdit.vue?vue&type=style&index=2&lang=scss&"
import style3 from "./ProposalsEdit.vue?vue&type=style&index=3&id=3567047e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3567047e",
  null
  
)

export default component.exports